import { AuthType } from '@corbado/shared-ui';
import React from 'react';
import { AuthFlow } from '../../components';
import FlowHandlerProvider from '../../contexts/FlowHandlerProvider';
const Login = ({ handleNavigationEvents, onLoggedIn, navigateToSignUp, initialAutoFocus = true, }) => {
    return (React.createElement(FlowHandlerProvider, { handleNavigationEvents: handleNavigationEvents, onLoggedIn: onLoggedIn, onChangeFlow: navigateToSignUp, initialFlowType: AuthType.Login },
        React.createElement(AuthFlow, { initialAutoFocus: initialAutoFocus })));
};
export default Login;
